import script from "./AutoAIModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIModal.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIModal.vue?vue&type=style&index=0&id=1b1caa84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1caa84"]])

export default __exports__